import dayjs from 'dayjs';

export const reductionFormValidations = (isEn) => ({
  startDate: {
    required: isEn ? 'Please select the start date.' : '시작일을 선택해주세요.',
  },
  endDate: {
    required: isEn ? 'Please select the end date.' : '종료일을 선택해주세요.',
  },
  realReductionBase: {
    required: isEn ? 'Please enter the baseline emission (absorption).' : '베이스라인 배출량 (흡수량)을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the baseline emission (absorption).' : '베이스라인 배출량 (흡수량)을 입력해주세요.';
      }
      return true;
    },
  },
  realReductionBusiness: {
    required: isEn ? 'Please enter the business emission (absorption).' : '사업 배출량 (흡수량)을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the business emission (absorption).' : '사업 배출량 (흡수량)을 입력해주세요.';
      }
      return true;
    },
  },
  realReductionLeak: {
    required: isEn ? 'Please enter the leakage.' : '누출량을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the leakage.' : '누출량을 입력해주세요.';
      }
      return true;
    },
  },
  realMonitorDesc: {
    required: isEn ? 'Please enter the monitoring description.' : '모니터링 설명을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the monitoring description.' : '모니터링 설명을 입력해주세요.';
      }
      return true;
    },
  },
  beforeImages: {
    validate: (value) => {
      if (!value || !Array.isArray(value) || value.length === 0) {
        return isEn ? 'Please upload at least one before image.' : '사전 이미지를 최소 1개 이상 업로드해주세요.';
      }
      return true;
    },
  },
  afterImages: {
    validate: (value) => {
      if (!value || !Array.isArray(value) || value.length === 0) {
        return isEn ? 'Please upload at least one after image.' : '사후 이미지를 최소 1개 이상 업로드해주세요.';
      }
      return true;
    },
  },
  evidence: {
    required: isEn ? 'Please upload the required evidence.' : '필수 증빙서류를 업로드해주세요.',
    validate: (value) => {
      if (!value || !Array.isArray(value)) {
        return isEn ? 'Please upload the required evidence.' : '필수 증빙서류를 업로드해주세요.';
      }
      // evidenceMapper 검증: isForce가 true인 경우 file 또는 reason이 필요
      for (let i = 0; i < value.length; i++) {
        const item = value[i];
        if (item?.evidence?.isForce) {
          if (!item.file && !item.reason) {
            return isEn
              ? `Please upload file or provide reason for required evidence: ${
                  item.evidence?.title || `Evidence ${i + 1}`
                }`
              : `필수 증빙서류에 파일을 업로드하거나 사유를 입력해주세요: ${
                  item.evidence?.title || `증빙서류 ${i + 1}`
                }`;
          }
        }
      }
      return true;
    },
  },
  additionalEvidence: {
    validate: (value) => {
      if (!value || !Array.isArray(value)) {
        return true; // optional
      }
      // additionalEvidence 검증: 각 항목에 title, file, reason이 모두 필요
      for (let i = 0; i < value.length; i++) {
        const item = value[i];
        if (!item.title || !item.title.trim()) {
          return isEn
            ? `Please enter the title for additional evidence ${i + 1}.`
            : `추가 증빙서류 ${i + 1}의 제목을 입력해주세요.`;
        }
        if (!item.file || !item.file.trim()) {
          return isEn
            ? `Please upload file for additional evidence ${i + 1}.`
            : `추가 증빙서류 ${i + 1}의 파일을 업로드해주세요.`;
        }
        if (!item.reason || !item.reason.trim()) {
          return isEn
            ? `Please enter the reason for additional evidence ${i + 1}.`
            : `추가 증빙서류 ${i + 1}의 사유를 입력해주세요.`;
        }
      }
      return true;
    },
  },
});

export const reductionInitialValues = {
  isExported: false,
  title: '',
  projectId: '',
  location: {
    addr1: '',
    addr2: '',
  },
  workplaceImages: [],
  area: '',
  subArea: '',
  methodologySeq: '',
  startDate: dayjs(),
  endDate: dayjs().add(1, 'year'),
  monitorDegree: 0,
  reductionBase: '',
  reductionBusiness: '',
  reductionLeak: '',
  reduction: '',
  realReductionBase: '',
  realReductionBusiness: '',
  realReductionLeak: '',
  realReduction: '',
  realMonitorDesc: '',
  beforeImages: [],
  afterImages: [],
  evidence: [],
  additionalEvidence: [],
};
